import { createBrowserHistory } from 'history';
// @ts-expect-error migrate upstream
import { getDashboardBaseUrl } from 'dashboard-components/lib/urlHelpers';
export const history = createBrowserHistory({
  basename: getDashboardBaseUrl()
});